import React, {useEffect} from "react";
import {WebRouteApp} from "@navigation";
import {Route, Routes} from "react-router-dom";
import {states} from "@recoils";
import {useSetRecoilState} from "recoil";
import {api} from "@utils";

export default function WebNavigation() {
  const setInfoData = useSetRecoilState(states.infoDataState);
  const setAdvData = useSetRecoilState(states.advDataState);

  async function getInfoData(attempt = 0) {
    if (attempt > 5) {
      return;
    }
    try {
      const {success, data, message} = await api.v1.info.getList();
      if (success) {
        setInfoData(data.result);
      } else {
        throw Error(message);
      }
    } catch (error) {
      console.error("getInfoData error", error);
      getInfoData(attempt + 1);
    }
  }

  async function getAdvData(attempt = 0) {
    if (attempt > 5) {
      return;
    }
    try {
      const {success, data, message} = await api.v1.adv.getList();
      if (success) {
        setAdvData(data.result);
      } else {
        throw Error(message);
      }
    } catch (error) {
      console.error("getAdvData error", error);
      getInfoData(attempt + 1);
    }
  }

  useEffect(() => {
    getInfoData();
    getAdvData();
  }, []);

  return (
    <Routes>
      <Route path="/*" element={<WebRouteApp />} />
    </Routes>
  );
}
